export default __webpack_public_path__ + "static/media/half_circle_blue.6ef51a58.svg";